export interface IUserTypes {
  value: string
  label: string
}

export const USER_TYPES = [
  {
    value: 'sole_trader',
    label: 'Sole Trader',
  },
  {
    value: 'ubo',
    label: 'Ubo',
  },
  {
    value: 'director',
    label: 'Director',
  },
  {
    value: 'admin',
    label: 'Admin',
  },
  {
    value: 'executor',
    label: 'Executor',
  },
  {
    value: 'accountant',
    label: 'Accountant',
  },
  {
    value: 'viewer',
    label: 'Viewer',
  },
]
